var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bell",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.821,
    height: 24,
    viewBox: "0 0 21.821 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bell-2",
    "data-name": "bell",
    d: "M18.366,8.637c0,4.376,1.033,7.114,2.02,8.728H5.436c.986-1.615,2.02-4.352,2.02-8.728a5.455,5.455,0,1,1,10.91,0Zm2.182,0a7.637,7.637,0,1,0-15.275,0c0,6.685-2.611,8.78-2.8,8.918a1.091,1.091,0,0,0,.614,1.992H22.73a1.091,1.091,0,0,0,.623-1.987c-.192-.142-2.805-2.237-2.805-8.924ZM13.854,22.273a1.092,1.092,0,0,1-1.491.4,1.055,1.055,0,0,1-.392-.39,1.091,1.091,0,0,0-1.9,1.081,3.273,3.273,0,0,0,5.666.007,1.091,1.091,0,1,0-1.888-1.1Z",
    transform: "translate(-2 -1)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.2fe2e1746cb4e61bcf8b39b8792d5b00.svg";
export { ForwardRef as ReactComponent };